




















import { defineComponent, ref, watch } from '@vue/composition-api'
import VButton from '@/components/VButton.vue'

export default defineComponent({
  name: 'VPopover',

  components: {
    VButton
  },

  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isClosable: {
      type: Boolean,
      default: true
    }
  },

  setup(props) {
    const popoverContent = ref<HTMLElement | null>(null)

    watch(
      () => props.isOpen,
      newValue => {
        if (newValue && popoverContent.value) {
          popoverContent.value.scroll(0, 0)
        }
      }
    )
  }
})
